import * as ContextMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { TrashIcon } from '@radix-ui/react-icons';

import { ContextMenuItem } from '../../primitives/context-menu';

type ContextMenuItemDeleteProps = React.ComponentPropsWithoutRef<typeof ContextMenuPrimitive.Item>;

export function ContextMenuItemDelete(props: ContextMenuItemDeleteProps) {
  return (
    <ContextMenuItem template="grid-icon-content" {...props}>
      <div className="flex justify-center">
        <TrashIcon className="size-4 text-destructive" />
      </div>
      <span className="text-destructive">Eliminar</span>
    </ContextMenuItem>
  );
}
